import React from 'react';

import { Card, Skeleton, Stack } from '@mantine/core';

import CircosPlot from './CircosPlot';
import Heatmap from './Heatmap';
import VGenes from './VGenes';
import VJGeneUsage from './VJGeneUsage';
import { LoadingContainer } from '../common/LoadingContainer';
import { RepertoireDataResponse } from '../generated/generatedOpenAPI';
import { DisplayType, FamilyOptions } from '../types/experiment';

interface VGeneDistributionProps {
  repertoireData: RepertoireDataResponse | undefined;
  isLoading?: boolean;
}

export default function VGeneDistribution({ repertoireData, isLoading }: VGeneDistributionProps) {
  const [selectedFamilyOption, setSelectedFamilyOption] = React.useState<FamilyOptions>(FamilyOptions.VH);
  const [selectedDisplayType, setSelectedDisplayType] = React.useState<DisplayType>(DisplayType.COUNT);

  if (isLoading) {
    return (
      <Card withBorder>
        <LoadingContainer height={300} />
      </Card>
    );
  }

  if (!repertoireData) {
    return (
      <Card withBorder>
        <Skeleton height={300} />
      </Card>
    );
  }

  return (
    <Card withBorder>
      <Stack gap="xl">
        <VJGeneUsage
          selectedFamilyOption={selectedFamilyOption}
          setSelectedFamilyOption={setSelectedFamilyOption}
          familyGraphRawData={repertoireData.familyGraphRawData}
          selectedDisplayType={selectedDisplayType}
          setSelectedDisplayType={setSelectedDisplayType}
        />
        <VGenes selectedFamilyOption={selectedFamilyOption} geneDistribution={repertoireData.geneDistribution} selectedDisplayType={selectedDisplayType} />
        <Heatmap heatmapData={repertoireData.heatmapData} />
        <CircosPlot circosData={repertoireData.circosData} />
      </Stack>
    </Card>
  );
}
